import { render, staticRenderFns } from "./ReviewTypeVendorFormModal.vue?vue&type=template&id=be6936e2"
import script from "./ReviewTypeVendorFormModal.ts?vue&type=script&lang=ts&external"
export * from "./ReviewTypeVendorFormModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be6936e2')) {
      api.createRecord('be6936e2', component.options)
    } else {
      api.reload('be6936e2', component.options)
    }
    module.hot.accept("./ReviewTypeVendorFormModal.vue?vue&type=template&id=be6936e2", function () {
      api.rerender('be6936e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Modals/ReviewTypeVendorFormModal.vue"
export default component.exports